/**
 * Holfuy live weather stations, keyed by the site they belong to.
 *
 * Wingbeat has a station at Witchieknowe (Holfuy station 1801). Add future
 * stations here keyed by any site_id or slug the site may use, plus a display
 * name. Look up with weatherStationForSite(site).
 */
export const WEATHER_STATIONS = {
  witchieknowe: { stationId: 1801, name: 'Witchieknowe' },
}

// Also match legacy numeric site_ids that refer to the same site.
const SITE_ID_ALIASES = {
  13: 'witchieknowe', // Witchie Knowe legacy id
  witchieknowe: 'witchieknowe',
}

/** The primary/featured station shown on the homepage. */
export const FEATURED_STATION = WEATHER_STATIONS.witchieknowe

/**
 * Return the Holfuy station config for a given site object, or null.
 * Matches on site_id, slug, or a slugified name.
 */
export function weatherStationForSite(site) {
  if (!site) return null
  const keys = [site.site_id, site.slug, (site.name || '').toLowerCase().replace(/\s+/g, '')]
  for (const k of keys) {
    if (k == null) continue
    const alias = SITE_ID_ALIASES[k]
    if (alias && WEATHER_STATIONS[alias]) return WEATHER_STATIONS[alias]
    if (WEATHER_STATIONS[k]) return WEATHER_STATIONS[k]
  }
  return null
}
